import React from 'react';

import '.././App.css';
import '../Styles/ArtPage.css';
import '../Styles/MainPage.css';

import {getProjectData, getThumbnails2D, getThumbnails3D, getAssets} from '../DataManagement/DataManagerArt.js';
import AssetProject from '../Components/AssetProject';

function ArtPage({
    artType
}) {

    const showImg = id => {
        window.location.href = getProjectData(id).artstation;
    }

    const renderArtworks = () => {
        const thumbnails = artType === '2d' ? getThumbnails2D() : getThumbnails3D();
        return (
            <>
                {thumbnails.map((thumbnail, index) => {
                    return <img className='thumbnail' src={thumbnail[1]} onClick={() => showImg(thumbnail[0])} alt='an artwork' key={`artwork-${index}`}/>
                })}
            </>
        );
    }

    const assetsList = getAssets(artType);
    
    return(
        <>
            <div className="artworksContainer">                
                <h1>Artworks</h1>
                {renderArtworks()}                

                {assetsList && (
                    <div className="assetsListContainer">
                        <h1>Products</h1>
                        {assetsList.map(asset => {
                            return(
                                <AssetProject projectData={asset}/>
                            )
                        })}
                    </div>
                )}
            </div>
        </>
    );

}

export default ArtPage;